import { IPayment } from "../types/ownerDashboard.types";
import {
  buildPropertyLabelMap,
  disambiguatePropertyLabels,
  getPropertyLabel,
  normalizeKenloPropertyId,
} from "./buildPropertyLabelMap";

export interface KenloPropertyOption {
  kenloPropertyId: string;
  label: string;
}

export function getKenloPropertyOptions(
  payments: IPayment[],
  excludeIds: string[] = []
): KenloPropertyOption[] {
  const labelMap = buildPropertyLabelMap(payments);
  const excluded = new Set(excludeIds.map(normalizeKenloPropertyId));
  const options: KenloPropertyOption[] = [];
  const seenPropertyIds = new Set<string>();

  payments.forEach((payment) => {
    const kenloPropertyId = normalizeKenloPropertyId(payment.kenlo_property_id);

    if (!kenloPropertyId || excluded.has(kenloPropertyId) || seenPropertyIds.has(kenloPropertyId)) {
      return;
    }

    seenPropertyIds.add(kenloPropertyId);
    options.push({
      kenloPropertyId,
      label: getPropertyLabel(kenloPropertyId, labelMap),
    });
  });

  return disambiguatePropertyLabels(options).sort((first, second) =>
    first.label.localeCompare(second.label, "pt-BR")
  );
}
